import api from '@/apis/ca/cAReceiptAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('approveVoucherCAReceiptList', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ca_receipt',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
